<script setup lang="ts">
import { inject, onMounted }       from "vue";
import { isLastLoop }              from "@TsUtils/helpers";
import { MainCarousel }            from "@TsUtils/MainCarousel";
import type { TypeAdvantagesData } from "@ViewPages/Main/Components/commonTypes";

type TypeProps = {
    advantages_data : TypeAdvantagesData,
    device_type : string,
};

const props = <TypeProps>inject('advantages_data'),
    isMobileDevice = props?.device_type == 'mobile';

const mainCarousel = new MainCarousel({
    idOrClassNameCarouseEl: '#advantages-items-carousel',
    idOrClassNameCarouselItemsEls: '#advantages-items-carousel-item-',
    idOrClassNameIndicatorEls: '#advantages-items-carousel-indicator-',
    data_list: props?.advantages_data,
    isMobileDevice: isMobileDevice,
});

onMounted(() => {
    if (isMobileDevice) {
        mainCarousel.handleCarousel();
    }
});

const carouselItemClass = [
        isMobileDevice
            ? 'hidden duration-200 ease-linear'
            : 'w-30% lg:w-1/5 xl-6:w-1/6',
        'min-w-44',
    ].join(' '),
    carouselWrapperClass = [
        isMobileDevice ? 'h-72' : 'flex flex-wrap max-sm-6:justify-evenly justify-between gap-4'
    ].join(' ');
</script>

<template>
    <div class="advantages__item">
        <div class="relative w-full overflow-hidden" id="advantages-items-carousel">
            <!-- Carousel wrapper -->
            <div :class="carouselWrapperClass">
                <!-- Item -->
                <div v-for="(data, index) in props?.advantages_data"
                     :key="index" :id="'advantages-items-carousel-item-' + (+index + 1)"
                     :class="[
                         carouselItemClass,
                         !isMobileDevice && isLastLoop(+index, props?.advantages_data) ? 'sm:mr-auto lg:mr-0' : '']"
                     @touchstart="mainCarousel.handleTouchStart"
                     @touchend="mainCarousel.handleTouchEnd"
                     @touchmove="mainCarousel.handleTouchMove">

                    <div v-html="data.img_tag"></div>

                    <div class="font-medium text-xl xl:text-0.1xl text-center break-words mb-5"
                         v-html="data.description">
                    </div>
                </div>
            </div>

            <!-- Slider indicators -->
            <div v-if="isMobileDevice"
                 class="absolute z-30 flex -translate-x-1/2 space-x-3 bottom-3 left-1/2">
                <button type="button" class="w-3 h-3 rounded-full" v-for="index in Object.keys(props?.advantages_data)"
                        :aria-current="+index == 0"
                        :aria-label="'Slide' + index"
                        :id="'advantages-items-carousel-indicator-' + (+index + 1)"
                ></button>
            </div>
        </div>
    </div>
</template>

<style scoped>

</style>
